// `/lib/types.ts`
export interface User {
  id: string;
  email: string;
  name?: string;
  consultations?: Consultation[]; // Use details like select, include in Prisma query to match what you need
  scenarios?: Scenario[];
}

export interface Consultation {
  id: string;
  title: string;
  createdAt: Date;
  updatedAt: Date;
  userId: string;
  user?: User;
  scenario: Scenario;
  scenarioId: string;
  messages?: Message[];
  tokenCount: number;
  stage: ConsultationStage;
}

export interface Message {
  id: string;
  createdAt: Date;
  consultationId: string;
  consultation?: Consultation;
  role: Role;
  content: string;
}

export interface HumanDetails {
  id: string;
  scenarioId: string;
  age: string;
  gender: string;
  mood: string;
  socioeconomicBackground: string;
}

export interface PartialHumanDetails {
  age?: string;
  gender?: string;
  mood?: string;
  socioeconomicBackground?: string;
}

export interface AnimalDetails {
  id: string;
  scenarioId: string;
  patientName: string;
  ownerName: string;
  patientSpecies: string;
  patientBreed: string;
  patientAge: string;
  patientSex: string;
  ownerAge: string;
  ownerGender: string;
  ownerDisposableIncome: string;
  petInsurance: string;
  ownerRelationshipToPatient: string;
  ownerComprehensionLevel: string;
  ownerResponseTone: string;
}

export interface PartialAnimalDetails {
  patientName?: string;
  ownerName?: string;
  patientSpecies?: string;
  patientBreed?: string;
  patientAge?: string;
  patientSex?: string;
  ownerAge?: string;
  ownerGender?: string;
  ownerDisposableIncome?: string;
  petInsurance?: string;
  ownerRelationshipToPatient?: string;
  ownerComprehensionLevel?: string;
  ownerResponseTone?: string;
}

export interface Scenario {
  id: string;
  createdAt: Date;
  isPublic: boolean;
  title: string;
  description: string;
  fullPrompt: string;
  feedbackPrompt: string;
  userId: string;
  user?: User;
  consultations?: Consultation[];
  scenarioType: ScenarioType;
  humanDetails?: HumanDetails; // Matches Prisma schema
  animalDetails?: AnimalDetails; // Matches Prisma schema
  duplicateOf?: string; // For duplicate scenarios
  duplicateScenarios?: Scenario[]; // List of scenarios that are duplicates
}

export interface PartialScenario {
  id?: string;
  userId?: string;
  title: string;
  description: string;
  fullPrompt: string;
  feedbackPrompt: string;
  scenarioType: ScenarioType;
  humanDetails?: PartialHumanDetails;
  animalDetails?: PartialAnimalDetails;
  isPublic?: boolean;
  duplicateOf?: string; // For duplicate scenarios
  duplicateScenarios?: Scenario[]; // List of scenarios that are duplicates
}

export enum ScenarioType {
  Human = 'Human',
  Animal = 'Animal',
}

export enum Role {
  user = "user",
  assistant = "assistant",
  system = "system",
}

export enum ConsultationStage {
  Consultation = "Consultation",
  Reflection = "Reflection",
  VetFeedback = "VetFeedback",
  ClientFeedback = "ClientFeedback",
}
